import menuDevtest from './menuDevtest';
import menuAdmin from './menuAdmin';
import menuCm from './menuCm';
import menuCmDirector from './menuCmDirector';
import menuFinance from './menuFinance';
import menuFinanceManager from './menuFinanceManager';
import menuFinanceDirector from './menuFinanceDirector';
import menuCommonAccounting from './menuCommonAccounting';
import menuLaw from './menuLaw';
import menuMallFinance from './menuMallFinance';
// import menuMallManager from './menuMallManager';
// import menuMallOpt from './menuMallOpt';
// import menuPm from './menuPm';
import menuBoss from './menuBoss';
import menuGeneralManager from './menuGeneralManager';
import menuGm from './menuGm';
import menuBusinessManager from './menuBusinessManager';
import menuBusinessAttache from './menuBusinessAttache';
// import menuBusinessDirector from './menuBusinessDirector';
import menuSupervisor from './menuSupervisor';
import menuChiefQualityOfficer from './menuChiefQualityOfficer';
import menuProductionManager from './menuProductionManager';
import menuProjectSupervisor from './menuProjectSupervisor';
import menuInsCommissioner from './menuInsCommissioner';
import menuED from './MenuExecutiveDean';
import menuMallMaterialManager from './menuMallMaterialManager';
import menuInvoice from './menuInvoice';


// import menuChieflegalOfficer from './menuChieflegalOfficer';
import menuYxbfzc from './menuYxbfzc';
import menuMarketingManager from './menuMarketingManager';
import menuSettlementsAccounting from './menuSettlementsAccounting';
import menuTaxAccounting from './menuTaxAccounting';
import menuPaymentDocumenter from './menuPaymentDocumenter'

import menuDxmbzjl from './menuDxmbzjl'


let allMenu = {
    'complyDean':menuED,
    'devtest': menuDevtest, 
    'admin': menuAdmin, 
    'cm': menuCm, 
    'cmDirector': menuCmDirector, 
    'finance': menuFinance, 
    'financeManager':menuFinanceManager,
    'financeDirector': menuFinanceDirector, 
    'commonAccounting': menuCommonAccounting,
    'law': menuLaw, 
    'mallFinance': menuMallFinance, 
    // 'mallManager': menuMallManager, 
    // 'mallOpt': menuMallOpt, 
    // 'pm': menuPm, 
    
    'boss': menuBoss, 

    'businessAttache': menuBusinessAttache, 
    'businessManager': menuBusinessManager, 
    // 'businessDirector':menuBusinessDirector,
    'generalManager': menuGeneralManager, 
    'GM':menuGm,
    'supervisor': menuSupervisor,
    'chiefQualityOfficer': menuChiefQualityOfficer,
    'productionManager': menuProductionManager,
    'projectSupervisor': menuProjectSupervisor,
    'insCommissioner': menuInsCommissioner,
    'mallMaterialManager':menuMallMaterialManager,
    // 'chieflegalOfficer':menuChieflegalOfficer,
    // 'MarketingVP':menuYxbfzc,
    'busienssDepartmentVP':menuYxbfzc,
    'marketingManager':menuMarketingManager,
    'billingCommissioner':menuInvoice,
    'settlementAccounting':menuSettlementsAccounting,
    'taxAccounting':menuTaxAccounting,
    'paymentDocumenter':menuPaymentDocumenter,
    'POGeneralManager':menuDxmbzjl
}

export default allMenu;


// WEBPACK FOOTER //
// ./src/menu/allMenu.js